export const messages = {
  en: {
    downShopHouse: {
      title: 'Down Shop House Management',
      queryConditions: 'Query Conditions',
      returnOrder: 'Return Order',
      applyReturn: 'Apply Return',
      search: 'Search',
      reset: 'Reset',
      orderId: 'Order ID',
      status: 'Status',
      applicant: 'Applicant',
      applyTime: 'Apply Time',
      remark: 'Remark',
      operation: 'Operation',
      audit: 'Audit',
      detail: 'Detail',
      delete: 'Delete',
      confirmDelete: 'Confirm Delete',
      cancel: 'Cancel',
      auditInfo: 'Audit Information',
      auditStatus: 'Audit Status',
      reason: 'Reason',
      submit: 'Submit',
      agree: 'Agree',
      reject: 'Reject'
    }
  },
  zh: {
    downShopHouse: {
      title: '退货单管理',
      queryConditions: '查询条件',
      returnOrder: '退货单',
      applyReturn: '申请退货',
      search: '查询',
      reset: '重置',
      orderId: '单号',
      status: '状态',
      applicant: '申请人',
      applyTime: '申请时间',
      remark: '备注',
      operation: '操作',
      audit: '审核',
      detail: '详情',
      delete: '删除',
      confirmDelete: '确认删除',
      cancel: '取消',
      auditInfo: '审核信息',
      auditStatus: '审核状态',
      reason: '原因',
      submit: '提交',
      agree: '同意',
      reject: '拒绝'
    }
  }
}